import $http from "../axios";

const state = {
  feedbacks: []
};

const getters = {
  feedbacks: state => {
    return state.feedbacks;
  },
  feedbacksReverse: state => {
    return JSON.parse(JSON.stringify(state.feedbacks));
  }
};

const actions = {
  getFeedbacks({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          `feedbacks?storeId=${data.storeId}&beginDate=${data.dates[0]}&endDate=${data.dates[1]}`
        )
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_FEEDBACKS", res.data.payload.feedbacks);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_FEEDBACKS(state, feedbacks) {
    state.feedbacks = feedbacks;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
